import { Check } from '@mui/icons-material';
import LoadingButton from '@mui/lab/LoadingButton';
import { Box, Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const TRANS_NS = 'billing';

type Props = {
  isLoading: boolean;
  handleSubmit: () => void;
  transNs?: string;
};

export const BillingEnterpriseBox = ({ isLoading, handleSubmit, transNs = TRANS_NS }: Props) => {
  const { t } = useTranslation(transNs);
  return (
    <Paper sx={{ py: 4, px: { md: 8, xs: 4 }, borderColor: 'primary.main', borderWidth: 2, textAlign: 'center' }}>
      <Typography variant={'h2'}>{t('enterprise.heading')}</Typography>

      <Box
        display={'flex'}
        flexDirection={'column'}
        alignItems={'center'}
        justifyContent={'center'}
        mt={{ md: 8, xs: 4 }}
      >
        <Typography whiteSpace={'break-spaces'} my={4} color={'text.secondary'}>
          {t('enterprise.description')}
        </Typography>
        <LoadingButton
          startIcon={<Check />}
          loading={isLoading}
          variant={'contained'}
          onClick={handleSubmit}
          size={'large'}
        >
          {t('enterprise.submit')}
        </LoadingButton>
      </Box>
    </Paper>
  );
};
